import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Spinner } from 'react-bootstrap';
import ImageUploader from 'react-images-upload';
import { connect } from 'react-redux';
import { apiUrl, businessName, mainApiUrl } from '../../utils/consts';
import queryString from 'query-string';
import CurrencyInput from 'react-currency-input';
import { withRouter } from 'react-router';
import { getImageUrls } from '../../utils/files';
import { formatMoney } from '../../utils/formatMoney';
import { daneCodes } from '../../utils/daneCodes';
import CreatableSelect from 'react-select/creatable';
import AddressesComponent from '../ShoppingCart/AddressesComponent';
import './styles/editUserProduct.scss';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

function ConnectedEditUserProduct(props) {

  const values = queryString.parse(props.location.search);
  const productId = values.id;

  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [productName, setProductName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [details, setDetails] = useState('');
  const [serverPhotos, setServerPhotos] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [photoFiles, setPhotoFiles] = useState([]);
  const [validated, setValidated] = useState(false);
  const [updated, setUpdated] = useState(false);

  // Variants.
  const [createVariant, setCreateVariant] = useState(false);
  const [variantName, setVariantName] = useState('');
  const [variantDetails, setVariantDetails] = useState('');
  const [variantPrice, setVariantPrice] = useState('');
  const [variantIndexToUpdate, setVariantIndexToUpdate] = useState(-1);
  const [variantHasOtherPrice, setVariantHasOtherPrice] = useState('NO');
  const [variants, setVariants] = useState([]);

  // Delivery.
  const [hasStock, setHasStock] = useState('SI');
  const [stock, setStock] = useState();
  const [hasDelivery, setHasDelivery] = useState('SI');
  const [deliveryDesc, setDeliveryDesc] = useState();
  const [weight, setWeight] = useState();
  const [deliveryInsurance, setDeliveryInsurance] = useState('SI');
  const [width, setWidth] = useState();
  const [length, setLength] = useState();
  const [height, setHeight] = useState();
  const [shipmentCities, setShipmentCities] = useState([]);
  const [shipmentCitiesValue, setShipmentCitiesValue] = useState('');
  const [countryShipment, setCountryShipment] = useState('SI');
  const [productType, setProductType] = useState('PRODUCTO');
  const [productCategory, setProductCategory] = useState('ACCESORIOS');
  const [userAddresses, setUserAddresses] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [deliveryAddressId, setDeliveryAddressId] = useState();
  const [deliveryPrice, setDeliveryPrice] = useState('');

  // Location.
  const [cityState, setCityState] = useState(daneCodes[0].name_depto);
  const [city, setCity] = useState(daneCodes[0].name_city);

  useEffect(() => {
    getData();
    getUserAddresses();
  }, []);

  useEffect(() => {
    if (updated) {
      alert('Producto actualizado.');
      props.history.push('/dashboard/productos');
    }
  }, [updated]);

  const getUserAddresses = () => {
    fetch(`${mainApiUrl}/addresses/user/${props.userId}`)
      .then(data => data.json())
      .then(addresses => {
        setUserAddresses(addresses);
        // if(addresses.length > 0) setDeliveryAddress(addresses[0]);
      });
  }

  const getData = async () => {
    setLoading(true);

    const productProm = await fetch(`${apiUrl}/products/get/${productId}`);
    const productResp = await productProm.json();

    if (productResp.success) {
      const { product } = productResp;

      const { location } = product;

      setProductName(product.name);
      setCity(location.split(',')[0].trim());
      setCityState(location.split(',')[1].trim())
      setDescription(product.description);
      setPrice(product.price);
      setDetails(product.details);
      setPhotos(product.photos);
      setServerPhotos(product.photos);
      setCountryShipment(product.countryShipment ? 'SI' : 'NO');
      setShipmentCities(product.shipmentCities ? product.shipmentCities : []);
      setProductType(product.productType);
      setProductCategory(product.productCategory);
      setVariants(product.variants && product.variants.length > 0 ?
        product.variants.map(item => ({
          name: item.name,
          details: item.details,
          otherPrice: item.otherPrice,
          price: item.price
        })
      ) : []);

      setHasStock(product.hasStock ? 'SI' : 'NO');
      if (product.hasStock) setStock(product.stock);
      setHasDelivery(product.hasDelivery ? 'SI' : 'NO');

      if (product.hasDelivery && product.deliveryInfo) {
        const { deliveryInfo } = product;

        setDeliveryDesc(deliveryInfo.description);
        setWeight(deliveryInfo.weight);
        setDeliveryInsurance(deliveryInfo.deliveryInsurance ? 'SI' : 'NO');
        setWidth(deliveryInfo.width);
        setLength(deliveryInfo.length);
        setHeight(deliveryInfo.height);
        setDeliveryAddressId(deliveryInfo.deliveryAddress._id);
      }
    }

    setLoading(false);
  };

  const createOption = label => ({
    label,
    value: label
  });

  const handleShipmentCityChange = value => {
    setShipmentCities(value);
  };

  const handleShipmentCityInputChange = value => {
    setShipmentCitiesValue(value);
  };

  const handleKeyDown = event => {

    switch (event.key) {
      case 'Enter':
      case 'Tab':
        if (shipmentCitiesValue) {
          setShipmentCities([...shipmentCities, createOption(shipmentCitiesValue) ]);
          setShipmentCitiesValue('');
        }

        event.preventDefault();

        break;
      default: return;
    }

  };

  const deleteVariant = item => {
    setVariants(variants.filter(variant => variant.name !== item.name));
  };

  const editVariant = (item, index) => {
    setVariantName(item.name);
    setVariantDetails(item.details);
    setVariantHasOtherPrice(item.otherPrice ? 'SI' : 'NO');
    setVariantPrice(item.otherPrice ? item.price : '');
    setVariantIndexToUpdate(index);
    setCreateVariant(true);
  };

  const handleCloseVariantModal = () => {
    setVariantName('');
    setVariantDetails('');
    setVariantPrice('');
    setVariantHasOtherPrice('NO');
    setVariantIndexToUpdate(-1);
    setCreateVariant(false);
  };

  const handleCreateVariant = () => {

    if (!variantName) return alert('Debes asignar un nombre para la variante.');
    if (variantHasOtherPrice === 'SI' && (!variantPrice || variantPrice <= 0)) return alert('Debes asignar un precio para la variante.');

    const newVariant = {
      name: variantName,
      details: variantDetails,
      otherPrice: variantHasOtherPrice === 'SI',
      price: variantHasOtherPrice === 'SI' ? variantPrice : 0
    };

    if (variantIndexToUpdate !== -1) {

      const newArr = [...variants];
      newArr.splice(variantIndexToUpdate, 1, newVariant);
      setVariants(newArr);

    } else {
      setVariants(variants.concat(newVariant));
    }

    alert(`Variante ${variantIndexToUpdate !== -1 ? 'editada' : 'agregada'}.`);

    setVariantName('');
    setVariantDetails('');
    setVariantPrice('');
    setVariantHasOtherPrice('NO');
    setVariantIndexToUpdate(-1);
    setCreateVariant(false);
  };

  const onDrop = (pictureFiles, pictureDataURLs) => {
    setServerPhotos(serverPhotos.filter(item => pictureDataURLs.includes(item)));
    setPhotos(pictureDataURLs);
    setPhotoFiles(pictureFiles);
  };

  const handleSubmit = async event => {

    event.preventDefault();
    event.stopPropagation();

    setValidated(true);

    const form = event.currentTarget;
    const deliveryAddress = userAddresses.find(item => `${item._id}` === deliveryAddressId);

    if (price <= 0) return alert('El precio debe ser mayor que 0.');
    if (countryShipment === 'NO' && (!shipmentCities || shipmentCities.length <= 0)) return alert('Debes agregar por lo menos una ciudad en donde el producto está disponible.');
    if (hasDelivery === 'SI') {
      if (!deliveryDesc) return alert('Debes asignar una descripción de envío');
      if (!weight || weight <= 0) return alert('Debes asignar un peso para el producto.');
      if (!length || length <= 0) return alert('Debes asignar un largo para el producto.');
      if (!height || height <= 0) return alert('Debes asignar un alto para el producto.');
      if (!width || width <= 0) return alert('Debes asignar un ancho para el producto.');
      if (!deliveryAddressId) alert('Debes elegir una dirección de envío.');
      if (!deliveryAddress) alert('Debes elegir una dirección de envío.');
    } else {
      if (deliveryPrice < 0) return alert('El precio de envío debe ser mayor o igual a 0.');
    }

    if (form.checkValidity()) {

      setUpdating(true);

      const photosArrayResp = await getImageUrls(photoFiles);

      if (!photosArrayResp.success) {
        alert('Error al editar el producto. Inténtalo nuevamente.');
      } else {

        const photosArray = serverPhotos.concat(photosArrayResp.urlArray);

        if (photosArray.length === 0) {
          setUpdating(false);
          return alert('Debes subir por lo menos una imagen.');
        }

        const location = `${city}, ${cityState}`;

        const updateProm = await fetch(`${apiUrl}/products/update`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            token: props.token,
            userId: props.userId,
            productId,
            businessName,
            name: productName,
            description,
            price,
            details,
            thumbnail: photosArray[0],
            photos: photosArray,
            variants: variants.map((item, index) => ({ ...item, id: index, price: item.otherPrice ? item.price : price })),
            hasStock,
            stock,
            hasDelivery,
            deliveryDesc,
            weight,
            height,
            width,
            length,
            deliveryInsurance,
            deliveryAddress,
            location,
            deliveryPrice,
            productType,
            productCategory,
            countryShipment: countryShipment === 'SI',
            shipmentCities
          })
        });

        const updateResp = await updateProm.json();

        if (updateResp.success) setUpdated(true);
        else alert(updateResp.message || 'Error al editar el producto. Inténtalo nuevamente.');
      }

      setUpdating(false);
    }
  };

  if (loading) {
    return (
      <div className="edit-user-product-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }

  return (
    <div className="edit-user-product-component">
      <Container>
        <Row>
          <Col>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Row>
                <Form.Group as={Col} md={8}>
                  <Form.Label className="app-label">Nombre del producto</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Nombre del producto"
                    value={productName}
                    onChange={event => setProductName(event.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group as={Col} md={4}>
                  <Form.Label className="app-label">Precio</Form.Label>
                  <CurrencyInput
                    className="form-control"
                    prefix='COP '
                    thousandSeparator="."
                    precision='0'
                    value={price}
                    onChangeEvent={(event, maskedvalue, floatvalue) => setPrice(floatvalue)}
                    required
                  />
                </Form.Group>

                <Form.Group as={Col} md={6}>
                  <Form.Label className="app-label">Departamento</Form.Label>
                  <Form.Control
                    as="select"
                    value={cityState}
                    onChange={e => setCityState(e.target.value)}
                    required
                  >
                    <option hidden></option>
                    {
                      Object.keys(groupBy(daneCodes, 'name_depto')).map((state, i) =>
                        <option
                          key={i}
                          value={state}
                        >
                          {state}
                        </option>
                      )
                    }
                  </Form.Control>
                </Form.Group>

                <Form.Group as={Col} md={6}>
                  <Form.Label className="app-label">Ciudad</Form.Label>
                  <Form.Control
                    as="select"
                    value={city}
                    onChange={e => setCity(e.target.value)}
                    required
                  >
                    <option hidden></option>
                    {
                      Object.values(groupBy(daneCodes.filter(entry => entry.name_depto === cityState), 'name_city')).map((city, i) =>
                        <option
                          key={i}
                          value={city[0].name_city}
                        >
                          {city[0].name_city}
                        </option>
                      )
                    }
                  </Form.Control>
                </Form.Group>

                <Form.Group as={Col} md={6}>
                  <Form.Label className="app-label">¿El producto puede ser enviado a cualquier lugar del país o solamente a ciudades específicas?</Form.Label>
                  <Form.Control
                    as="select"
                    value={countryShipment}
                    onChange={event => setCountryShipment(event.target.value)}
                  >
                    <option value="SI">Todo el país</option>
                    <option value="NO">Ciudades específicas</option>
                  </Form.Control>
                </Form.Group>

                <Form.Group as={Col} md={12}>
                  {
                    countryShipment === 'NO' &&
                    <>
                      <Form.Label className="app-label">Escribe las ciudades en donde tu producto está disponible</Form.Label>
                      <CreatableSelect
                        components={{ DropdownIndicator: null }}
                        inputValue={shipmentCitiesValue}
                        menuIsOpen={false}
                        onChange={handleShipmentCityChange}
                        onInputChange={handleShipmentCityInputChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Escribe una ciudad y coloca enter..."
                        value={shipmentCities}
                        isMulti
                        isClearable
                      />
                    </>
                  }
                </Form.Group>

                <Form.Group as={Col} md={6}>
                  <Form.Label className="app-label">Tipo del producto</Form.Label>
                  <Form.Control
                    as="select"
                    value={productType}
                    onChange={event => setProductType(event.target.value)}
                  >
                    <option value="PRODUCTO">Producto</option>
                    <option value="SERVICIO">Servicio</option>
                  </Form.Control>
                </Form.Group>

                <Form.Group as={Col} md={6}>
                  <Form.Label className="app-label">Categoría del producto</Form.Label>
                  <Form.Control
                    as="select"
                    value={productCategory}
                    onChange={event => setProductCategory(event.target.value)}
                  >
                    {
                      productType === 'PRODUCTO' ?
                      <>
                        <option value="ACCESORIOS">Accesorios</option>
                        <option value="ROPA">Ropa</option>
                        <option value="COMESTIBLES_ALIMENTOS">Comestibles y alimentos</option>
                        <option value="ARTESANIAS">Artesanías</option>
                        <option value="PUBLICIDAD">Publicidad</option>
                        <option value="OTROS">Otros</option>
                      </> :
                      <>
                        <option value="LOGISTICOS">Servicios logísticos</option>
                        <option value="HOGAR">Servicios para el hogar</option>
                        <option value="BELLEZA">Servicios de belleza</option>
                        <option value="OTROS">Otros</option>
                      </>
                    }
                  </Form.Control>
                </Form.Group>

                <Form.Group as={Col} md={12}>
                  <Form.Label className="app-label">Descripción</Form.Label>
                  <Form.Control
                    type="text"
                    as="textarea"
                    rows="3"
                    placeholder="Describe el producto"
                    value={description}
                    onChange={event => setDescription(event.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group as={Col} md={12}>
                  <Form.Label className="app-label">Subir fotos del producto</Form.Label>
                  <ImageUploader
                    className="multImageInput"
                    withIcon={false}
                    withPreview={true}
                    fileContainerStyle={{ borderRadius: '5px', borderStyle: 'solid', borderColor: 'lightgray', borderWidth: 'thin' }}
                    buttonText='Escoge una o varias imágenes'
                    label='Tamaño máximo por imagen: 5mb, formatos: jpg, gif, png'
                    onChange={onDrop}
                    imgExtension={['.jpeg', '.jpg', '.gif', '.png', '.gif']}
                    maxFileSize={5242880}
                    fileSizeError='Archivo demasiado grande. Máximo 5mb.'
                    fileTypeError='Extension del archivo no soportado.'
                    defaultImages={photos}
                  />
                </Form.Group>
                <Form.Group as={Col} md={12}>
                  <Form.Label className="app-label">Detalles (opcional)</Form.Label>
                  <Form.Control
                    type="text"
                    as="textarea"
                    rows="3"
                    placeholder="Detalles adicionales del producto"
                    value={details}
                    onChange={event => setDetails(event.target.value)}
                  />
                </Form.Group>

                <Col xs={12}>
                  <Form.Label className="app-label">Variantes</Form.Label>
                  {
                    variants.map((item, index) => 
                      <div key={index} className="variant-item">
                        <span className="variant-name">{item.name} - ${formatMoney(item.price || price)}</span>
                        <span className="icons">
                          <i className="fas fa-edit" onClick={() => editVariant(item, index)} />
                          <i className="fas fa-trash-alt delete-icon" onClick={() => deleteVariant(item)} />
                        </span>
                        <hr />
                      </div>
                    )
                  }
                  <Button className="app-button" onClick={() => setCreateVariant(true)}>
                    Agregar variante
                  </Button>
                  <hr />
                </Col>
                <Form.Group as={Col} md={6}>
                  <Form.Label className="app-label">¿Este producto cuenta con inventario limitado?</Form.Label>
                  <Form.Control
                    as="select"
                    value={hasStock}
                    onChange={event => setHasStock(event.target.value)}
                  >
                    <option value="SI">Si</option>
                    <option value="NO">No</option>
                  </Form.Control>
                </Form.Group>
                {
                  hasStock === 'SI' ?
                  <Form.Group as={Col} md={6}>
                    <Form.Label className="app-label">Número de productos disponibles</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Inventario"
                      value={stock}
                      onChange={event => setStock(event.target.value)}
                      required
                    />
                  </Form.Group> :
                  <Col md={6}></Col>
                }
                <Col xs={12}><hr /></Col>

                <Form.Group as={Col} md={12}>
                  <Form.Label className="app-label">¿Deseas realizar tus envíos a través de nibi?</Form.Label>
                  <Form.Text className="text-muted">
                    Al seleccionar esta opción, cada vez que realices una venta enviaremos una guía de envío a tu correo electrónico para que puedas llevar el producto a algún punto de la compañía de envíos y así realizar la entrega del mismo.
                    En caso de que no selecciones esta opción, deberás hacerte cargo de la logística de entrega de tu producto.
                  </Form.Text>
                  <Form.Control
                    as="select"
                    value={hasDelivery}
                    onChange={event => setHasDelivery(event.target.value)}
                  >
                    <option value="SI">Si</option>
                    <option value="NO">No</option>
                  </Form.Control>
                </Form.Group>
                {
                  hasDelivery === 'SI' ?
                  <>
                    <Form.Group as={Col} md={4}>
                      <Form.Label className="app-label">¿Qué envías?</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Ropa, documentos, accesorios, etc"
                        value={deliveryDesc}
                        onChange={event => setDeliveryDesc(event.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <Form.Label className="app-label">Peso (Kg)</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Peso"
                        value={weight}
                        onChange={event => setWeight(event.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <Form.Label className="app-label">¿Seguro de envío?</Form.Label>
                      <Form.Control
                        as="select"
                        value={deliveryInsurance}
                        onChange={event => setDeliveryInsurance(event.target.value)}
                      >
                        <option value="SI">Si</option>
                        <option value="NO">No</option>
                      </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <Form.Label className="app-label">Largo (Cm)</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Largo"
                        value={length}
                        onChange={event => setLength(event.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <Form.Label className="app-label">Ancho (Cm)</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Ancho"
                        value={width}
                        onChange={event => setWidth(event.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <Form.Label className="app-label">Alto (Cm)</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Alto"
                        value={height}
                        onChange={event => setHeight(event.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group as={Col} md={6}>
                      <Form.Label className="app-label">Dirección de donde se envía el producto</Form.Label>
                      <Form.Control
                        as="select"
                        value={deliveryAddressId}
                        onChange={event => setDeliveryAddressId(event.target.value)}
                        required
                      >
                        {
                          userAddresses.map(address =>
                            <option 
                              key={address._id} 
                              value={address._id}
                            >
                              {address.short} {`(${address.street} , ${address.city})`}
                            </option>
                          )
                        }
                      </Form.Control>
                      <div style={{ marginTop: '10px' }}>
                        <Button
                          variant="outline-success"
                          onClick={() => setShowAddressModal(true)}
                        >
                          Agregar nueva dirección
                        </Button>
                      </div>
                    </Form.Group>
                  </> :
                  <>
                    <Form.Group as={Col} md={6}>
                      <Form.Label className="app-label">Precio de envío</Form.Label>
                      <Form.Text className="text-muted">
                        Ingresa el precio estimado del envío de tu producto. (este precio se sumará al precio final del producto).
                      </Form.Text>
                      <CurrencyInput
                        className="form-control"
                        prefix='COP '
                        thousandSeparator="."
                        precision='0'
                        value={deliveryPrice}
                        onChangeEvent={(event, maskedvalue, floatvalue) => setDeliveryPrice(floatvalue)}
                        required
                      />
                    </Form.Group>
                  </>
                }
                <Col xs={12}><hr /></Col>

                <Button type="submit" className="app-button center" disabled={updating}>
                  {
                    updating ? <Spinner animation="border" variant="warning" size="sm" /> : 'Actualizar'
                  }
                </Button>
              </Form.Row>
            </Form>
          </Col>
        </Row>
      </Container>

      <Modal show={createVariant} onHide={handleCloseVariantModal} size="lg">
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Row>
              <Form.Group as={Col} md={12}>
                <Form.Label className="app-label">Nombre de la variante</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ej: Blanco, talla S"
                  value={variantName}
                  onChange={event => setVariantName(event.target.value)}
                  required
                />
              </Form.Group>
              <Form.Group as={Col} md={12}>
                <Form.Label className="app-label">Detalles (Opcional)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Detalles adicionales de esta variante"
                  value={variantDetails}
                  onChange={event => setVariantDetails(event.target.value)}
                />
              </Form.Group>
              <Form.Group as={Col} md={6}>
                <Form.Label className="app-label">¿Esta variante tiene un precio diferente?</Form.Label>
                <Form.Control
                  as="select"
                  value={variantHasOtherPrice}
                  onChange={event => setVariantHasOtherPrice(event.target.value)}
                >
                  <option value="NO">No</option>
                  <option value="SI">Si</option>
                </Form.Control>
              </Form.Group>
              {
                variantHasOtherPrice === 'SI' &&
                <Form.Group as={Col} md={6}>
                  <Form.Label className="app-label">Precio de esta variante</Form.Label>
                  <CurrencyInput
                    className="form-control"
                    prefix='COP '
                    thousandSeparator="."
                    precision='0'
                    value={variantPrice}
                    onChangeEvent={(event, maskedvalue, floatvalue) => setVariantPrice(floatvalue)}
                    required
                  />
                </Form.Group>
              }
              <Col xs={12}>
                <Button className="app-button" onClick={handleCreateVariant}>
                  {variantIndexToUpdate !== -1 ? 'Editar' : 'Crear'} variante
                </Button>
              </Col>
            </Form.Row>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showAddressModal} onHide={() => setShowAddressModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Agrega una dirección de envío</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddressesComponent
            userId={props.userId}
            refreshAddresses={() => getUserAddresses()}
            closeModal={() => setShowAddressModal(false)}
          />
        </Modal.Body>
      </Modal>

    </div>
  );
}

const EditUserProduct = connect(select)(ConnectedEditUserProduct);

export default withRouter(EditUserProduct);
